// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
   overflow: hidden;
}
.senderList {
   list-style: none;
   margin: 0;
   line-height: 15px;
   padding: 0px 5px 5px 20px;
}
li {
   /* margin-top: 8px; */
   position: relative;
}
a {
   color: #666;
   cursor: pointer;
   display: inline-block;
   position: relative;
   word-break: break-all;
   white-space: nowrap;
}
a:hover {
   color: #ffa726;
}

a.active {
   color: #ff8326;
   cursor: initial;
}

a.active:hover {
   text-decoration: none;
}
i {
   display: block;
   line-height: 20px;
   width: 20px;
   height: 20px;
   text-align: center;
   transition: transform .3s;
   position: absolute;
   top: 0;
   left: 0;
}
i.fa-spinner {
   left: -1px;
}
img {
   display: block;
   width: 20px;
   height: 20px;
   position: absolute;
   top: 0;
   left: -25px;
}
.expanded {
   transform: rotate(90deg);
}
.error {
   margin-left: 8px;
   margin-top: 5px;
}
a.selectedPath {
   color: #00bed6;
}
a.denied {
   cursor: default;
   color: #a7a6a6;
   text-decoration: none;
}
.denied img {
   filter: grayscale(100%);
   opacity: .8;
}
div.sender {
   font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sender-list/sender-list.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;AACnB;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,iBAAiB;GACjB,yBAAyB;AAC5B;AACA;GACG,qBAAqB;GACrB,kBAAkB;AACrB;AACA;GACG,WAAW;GACX,eAAe;GACf,qBAAqB;GACrB,kBAAkB;GAClB,qBAAqB;GACrB,mBAAmB;AACtB;AACA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,qBAAqB;AACxB;AACA;GACG,cAAc;GACd,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,yBAAyB;GACzB,kBAAkB;GAClB,MAAM;GACN,OAAO;AACV;AACA;GACG,UAAU;AACb;AACA;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,MAAM;GACN,WAAW;AACd;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,gBAAgB;GAChB,eAAe;AAClB;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;GACf,cAAc;GACd,qBAAqB;AACxB;AACA;GACG,uBAAuB;GACvB,WAAW;AACd;AACA;GACG,eAAe;AAClB","sourcesContent":[".container {\n   overflow: hidden;\n}\n.senderList {\n   list-style: none;\n   margin: 0;\n   line-height: 15px;\n   padding: 0px 5px 5px 20px;\n}\nli {\n   /* margin-top: 8px; */\n   position: relative;\n}\na {\n   color: #666;\n   cursor: pointer;\n   display: inline-block;\n   position: relative;\n   word-break: break-all;\n   white-space: nowrap;\n}\na:hover {\n   color: #ffa726;\n}\n\na.active {\n   color: #ff8326;\n   cursor: initial;\n}\n\na.active:hover {\n   text-decoration: none;\n}\ni {\n   display: block;\n   line-height: 20px;\n   width: 20px;\n   height: 20px;\n   text-align: center;\n   transition: transform .3s;\n   position: absolute;\n   top: 0;\n   left: 0;\n}\ni.fa-spinner {\n   left: -1px;\n}\nimg {\n   display: block;\n   width: 20px;\n   height: 20px;\n   position: absolute;\n   top: 0;\n   left: -25px;\n}\n.expanded {\n   transform: rotate(90deg);\n}\n.error {\n   margin-left: 8px;\n   margin-top: 5px;\n}\na.selectedPath {\n   color: #00bed6;\n}\na.denied {\n   cursor: default;\n   color: #a7a6a6;\n   text-decoration: none;\n}\n.denied img {\n   filter: grayscale(100%);\n   opacity: .8;\n}\ndiv.sender {\n   font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
